import {
  createMultiStyleConfigHelpers, // StyleThemingProps,
} from '@chakra-ui/react'
import mangoLogo from '~/assets/mango-gradientLogo_std.png'
import { asChakraVariable } from '~/themes/colors/colors'

const PopupStyleParts = ['logo'] as const

const helpers = createMultiStyleConfigHelpers(PopupStyleParts)

export const PopupColors = {
  Content: {
    Background: {
      Default: {
        default: 'achromatic.transparent',
      },
      Hover: {
        default: 'var(--chakra-colors-gray-300)',
      },
      Active: {
        default: 'var(--chakra-colors-gray-400)',
      },
      Selected: {
        default: 'var(--chakra-colors-gray-400)',
      },
    },
  },
  Icon: {
    Default: {
      default: 'var(--chakra-colors-gray-800)',
    },
    Hover: {
      default: 'var(--chakra-colors-gray-1000)',
    },
    Active: {
      default: 'var(--chakra-colors-gray-1300)',
    },
  },
  FontColor: {
    Default: {
      default: 'var(--chakra-colors-gray-800)',
    },
    Hover: {
      default: 'var(--chakra-colors-gray-1000)',
    },
    Active: {
      default: 'var(--chakra-colors-gray-1300)',
    },
  },
}

export const PopupStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    logoWrapper: {
      height: '100%',
      cursor: 'pointer',
    },
    logo: {
      backgroundImage: `url(${mangoLogo})`,
      width: '90px',
      height: '100%',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    showHideIconWrapper: {
      marginLeft: '0.5rem',
      height: '1.75rem',
      width: '1.75rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      borderRadius: '0.5rem',
      borderColor: 'transparent',
      borderStyle: 'solid',
      borderWidth: '1px',
      alignItems: 'center',
      flexShrink: '0',
      cursor: 'pointer',
      '&:hover': {
        bg: PopupColors.Content.Background.Hover.default,
        '> .show-hide-message-icon': {
          color: PopupColors.Icon.Hover.default,
        },
      },
      '&:active': {
        bg: PopupColors.Content.Background.Active.default,
        '> .show-hide-message-icon': {
          color: PopupColors.Icon.Active.default,
        },
      },
      '&:selected': {
        bg: PopupColors.Content.Background.Selected.default,
        boxShadow: `0px 1px 0px 0px ${asChakraVariable(
          PopupColors.Content.Background.Selected.default,
        )}`,
      },
    },
    showHideToggleWrapper: {
      marginLeft: '0.5rem',
    },
    showHideToggle: {},
    showHideIcon: {
      boxSize: '1.15rem',
      fill: 'var(--chakra-colors-mango-purple)',
    },
  },
})
